import React, { useState, useEffect } from "react";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState([]);

  const axiosAPI = useAxios(); // Use the custom Axios instance

  const fetchDashboardData = async () => {
    setLoading(true); // Set loading state to true before fetching data
    try {
      const response = await axiosAPI.get("/api/dashboard/dashboard-data");
      setDashboardData(response.data); // Set the fetched data to state
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data is fetched
    }
  };

  // Fetch dashboard data when the component mounts
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // Ensure you are using empty array as fallback
  const total_students = (dashboardData && dashboardData.total_students) || 0;
  const total_recorded_videos =
    (dashboardData && dashboardData.total_recorded_videos) || 0;
  const total_online_tests =
    (dashboardData && dashboardData.total_online_tests) || 0;
  const total_fees = (dashboardData && dashboardData.total_fees) || 0;

  // Show Bootstrap spinner while loading
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="page-inner">
        <div className="row">
          {/* Online Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center icon-success bubble-shadow-small">
                      <i className="fas fa-chalkboard-teacher"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Agents</p>
                      <h4 className="card-title">{total_students}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Offline Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center icon-danger bubble-shadow-small">
                      <i className="fas fa-chalkboard"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Properties</p>
                      <h4 className="card-title">{total_fees}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center border ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-desktop"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Enquiries</p>
                      <h4 className="card-title">{total_recorded_videos}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Media Files Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-folder-open"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Upcoming</p>
                      <h4 className="card-title">{total_online_tests}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
